import script from "./UpdateAccountingProductGroupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateAccountingProductGroupModal.vue?vue&type=script&setup=true&lang=js"

import "./UpdateAccountingProductGroupModal.vue?vue&type=style&index=0&id=35f18d66&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35f18d66"]])

export default __exports__